export default "__VITE_ASSET__JcLRt$LS__"